module.exports = __webpack_public_path__ + "img/facebook.c16f9ca2.svg";